import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import { IApplyLastFilters } from '../filters/actions';
import { IThunkActionCreator } from '../../types/store';

export interface ISaveLastFilters {
  type: 'ISaveLastFilters';
  filters: IGetVillageListRequestSchema;
}

export interface IClearLastFilters {
  type: 'IClearLastFilters';
}

export function saveLastFilters(): IThunkActionCreator {
  return (dispatch, getState) => {
    dispatch<ISaveLastFilters>({
      filters: { ...getState().filters },
      type: 'ISaveLastFilters',
    });
  };
}

export function clearLastFilters(): IClearLastFilters {
  return {
    type: 'IClearLastFilters',
  };
}

export const saveFilters = (filters: IGetVillageListRequestSchema): IApplyLastFilters => ({
  filters,
  type: 'IApplyLastFilters',
});

export function applyLastFilters(): IThunkActionCreator {
  return (dispatch, getState) => {
    const { lastFilters } = getState();
    if (lastFilters) {
      dispatch(saveFilters(lastFilters));
      dispatch<IClearLastFilters>({
        type: 'IClearLastFilters',
      });
    }
  };
}

export type Action = IClearLastFilters | ISaveLastFilters;
